module.exports = __webpack_public_path__ + "static/media/picpay.b51b49c5.png";